import React, { useState } from 'react'
import {
	DialogContent,
	Dialog,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	DialogActions,
	SelectChangeEvent,
} from '@mui/material'
import {
	ApplicationRowData,
	SiteConfiguration,
} from '@matech/thebigpos-sdk'
import { Button } from '../Button'
import { formatDate, isDarkMode } from '../../services/helper'

export type ModalLoanAppSelectorProps = {
	visible: boolean
	setVisible: (visible: boolean) => void
	siteConfig: SiteConfiguration | null
	loanApplications: ApplicationRowData[]
	setActiveLoanApp: (app: ApplicationRowData) => void
}
const ModalLoanAppSelector = ({
	visible,
	setVisible,
	siteConfig,
	loanApplications,
	setActiveLoanApp,
}: ModalLoanAppSelectorProps) => {
	const [selected, setSelected] = useState('')
	const [selectedApp, setSelectedApp] =
		useState<ApplicationRowData | null>(null)

	const handleSelectOnChange = (event: SelectChangeEvent) => {
		const app = loanApplications.filter(
			(loan) => loan.loanID === event.target.value
		)
		setSelected(event.target.value)
		setSelectedApp(app[0])
	}

	const handleContinue = () => {
		if (!selectedApp) return

		setActiveLoanApp(selectedApp)
		setVisible(false)
	}

	return (
		<Dialog open={visible} aria-labelledby="responsive-dialog-title">
			<DialogContent>
				<div>
					{siteConfig?.logoUrl && (
						<img
							alt={`${siteConfig.companyName} Logo`}
							className="w-full"
							src={
								isDarkMode() && siteConfig?.darkModeLogoUrl
									? siteConfig.darkModeLogoUrl
									: siteConfig?.logoUrl
							}
						/>
					)}
				</div>
				<div className="text-center mt-5 mb-4 font-bold text-lg">
					Which loan application would you like to work on?
				</div>
				<div className="w-full">
					<FormControl sx={{ width: '100%', mt: 1 }}>
						<InputLabel>Loan Applications</InputLabel>
						<Select
							value={selected}
							label="Please select a loan file"
							onChange={(event) => handleSelectOnChange(event)}
						>
							{loanApplications?.map((app) => {
								const formattedApplicationDate = ` - ${formatDate(app.applicationDate, false)}`
								return (
									<MenuItem
										value={app.loanID}
										key={`menu-item__${app.loanID}`}
									>
										{`${app.loanPurpose} - $${app.loanAmount} - ${app.subjectPropertyCity ?? 'TBD'}, ${app.subjectPropertyState ?? 'TBD'} ${app.applicationDate ? formattedApplicationDate : ''}`}
									</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</div>
			</DialogContent>
			<DialogActions className="mr-5 mb-2">
				<Button
					onClick={handleContinue}
					disabled={selected.length < 1}
					text={selected.length < 1 ? 'Choose a file' : 'Continue'}
				/>
			</DialogActions>
		</Dialog>
	)
}

export default ModalLoanAppSelector
